import { render, staticRenderFns } from "./LinksLaureano.vue?vue&type=template&id=01a6f8fa&scoped=true"
import script from "./LinksLaureano.vue?vue&type=script&lang=js"
export * from "./LinksLaureano.vue?vue&type=script&lang=js"
import style0 from "./LinksLaureano.vue?vue&type=style&index=0&id=01a6f8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6f8fa",
  null
  
)

export default component.exports